import * as React from "react";
import * as _ from 'lodash';
import moment from "moment";
import {useParams} from "react-router-dom";
import {
    Box,
    Grid,
    IconButton,
    Button,
    ButtonGroup,
    FormControl,
    Select,
    MenuItem,
    FormLabel,
    TextField,
    Typography
} from "@mui/material";
import {loadPatientById, patient} from '../../store/reducers/patient';
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import AdmissionSection from "./admissionSection";
import {AgyleLogoIcon, AlertIcon} from '../../components/icons/icons';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import { useHistory } from "react-router-dom";
import PatientHelper from "../../controls/helpers/patientHelper";
import {additionalData, loadPatientAdditionalData} from "../../store/reducers/additionalData";
import {user} from "../../store/reducers/user";
import clsx from "clsx";
import {ToggleRadioNamed} from "./components";
import {demographicSchema, FromDemographicsSection} from "./demographicsSection";
import {basicInformationSchema, BasicInformationSection} from "./basicInformationsSection";
import {proceduresSchema, FromProceduresSection, ProcedureItem, procedureEditSchema} from './proceduresSection';
import {clinicalTeamNotesSchema, ClinicalTeamNotesSection, referralNotesSchema, ReferralNotesSection} from "./referalNotesSection";
import DatePicker from "@mui/lab/DatePicker";
import API from "../../app/api";
import {
    getAdmissionConfig,
    getConfig,
    reload,
    setMarkedOperation,
    setOperations,
} from '../../store/reducers/booked_admissions';
import {Autocomplete} from '@mui/lab';
import {useEffect, useState} from 'react';
import {setSnackbar} from '../../store/reducers/globals';
import {AdmissionConsultant} from '../../controls/agyle/dictionaries';
import config from '../../app/config';
import $ from "jquery";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Tooltip from '@mui/material/Tooltip';
import {StyledBadge} from '../../components/header/patientInfo';
import Popover from '@mui/material/Popover';

const useStyles = makeStyles((theme) => ({
    header: {
        height: "57px",
        padding: "12px 10px",
    },
    headerLeft: {
        height: "100%",
        display: "flex",
        flexDirection: "row"
    },
    headerRight: {
        height: "100%",
        display: "flex",
        flexDirection: "row-reverse"
    },
    subHeader:{
        height: "64px",
        border: "0px solid red",
        paddingLeft: "5px",
        paddingRight: "10px"
    },
    arrowIcon: {
        marginLeft: "10px",
        marginRight: "10px",
        marginTop: "6px",
        width: "18px",
        height: "18px"
    },
    appLogo: {
        width: "30px",
        height: "30px"
    },
    patientName: {
        display: "inline-flex",
        lineHeight: "30px",
    },
    patientFamilyName: {
        textTransform:"uppercase"
    },
    patientBadge: {
        display: "inline-flex",
        backgroundColor: theme.palette.background.patientBadge,
        borderRadius: "5px",
        padding: "3px 16px 4px"
    },
    patientBadgeItem: {
        marginRight: "15px",
    },
    badgeLabel: {
        fontSize: "0.755rem",
        fontWeight: 200
    },
    badgeValue: {
        fontSize: "0.725rem",
        fontWeight: 700
    },
    overseeingConsultant: {
        "& .MuiInputLabel-root": {
            top: "-8px"
        },
        "& .MuiAutocomplete-inputRoot": {
            paddingBottom: "0px",
            paddingTop: "0px",
        }
    },
    formTypeButton: {
        width: "120px",
        display: "inline-block",
        textAlign: "center",
        margin: "4px 4px",
        backgroundColor: theme.palette.background.paperDarker,
        color: theme.palette.admissionForm.labelColor,
        borderRadius: "4px",
        padding: "3px 0px",
        cursor: "pointer"
    },
    dcLabel: {
        display: "inline-block",
        position: "relative",
        top: "3px",
        paddingRight: "3px",
        fontSize: "14px",
        fontStyle: "italic",
        fontWeight: "500"
    },
    alert: {
        padding: "10px",
        borderBottom: "1px solid black",
    },
    alertType: {
        textAlign: "center"
    },
    alertGroup: {
        fontWeight: "bold",
        paddingTop: "10px"
    },
    alertBoldText: {
        fontWeight: "bold"
    },
    alertText: {
        paddingTop: "10px"
    },
}));

export const useStylesInputControls = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "32px",
        fontWeight: "500",
        fontSize: "0.95rem",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    }
}));

const patientBadgeItems = [
    {
        item: "born",
        toDisplay: "Born",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientDob(data.patient) : "";
        }
    },
    {
        item: "age",
        toDisplay: "Age",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientAge(data.patient) : "";
        }
    },
    {
        item: "gender",
        toDisplay: "Gender",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientGender(data.patient) : "";
        }
    },
    {
        item: "hospital",
        toDisplay: "Hos No",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientHospitalNumber(data.patient) : "";
        }
    },
    {
        item: "nhs",
        toDisplay: "NHS No",
        value: (data) => {
            return data && data.patient ? PatientHelper.getPatientNSHNumber(data.patient) : "";
        }
    },
    {
        item: "bed",
        toDisplay: "Bed",
        value: (data) => {
            return data.patientBed;
        }
    },
]

const baseAdmissionData = {
    _createdDate: moment(),
    _createdBy: "",
    opType: "TCI",
    status: "WORKLIST"
}

export const notesSchema = {
    notes: "",
    procedureNotes: "",
    overseeingConsultant: null
}

const personCompletingRecordSchema = {
    personCompRecord: {
        personCompleting: null,
        role: null,
        recordCompleted: null
    }
    //mtu - record competing

}

export function PatientAlertsComponent(props) {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const {t} = useTranslation();

    const getPatientAlert = () => {

        let arr = [];

        _.forEach(props.patientObject?.alerts, (alert, index) => {
            if (!alert.hideInUI) {
                let endDateStr = '';
                if (alert.endDate != null) {
                    endDateStr = ' Until' + ': '
                        + moment.utc(alert.endDate).format(config.defaultDateFormat);
                }
                arr.push(
                    <div key={index} className={classes.alert + " grid"}>
                        <div className={classes.alertType}>
                            {alert.alertType == null ? "" : alert.alertType}
                            <div className={classes.alertGroup}>
                                {alert.group == null ? "" : alert.group}
                            </div>
                        </div>
                        <div>
                            <div className={classes.alertBoldText}>
                                {alert.allergen == null ? "" : alert.allergen}
                            </div>
                            <div className={alert.allergen == null ? "" : classes.alertText}>
                                {alert.description == null ? "" : alert.description}
                            </div>
                            <div className={classes.alertText}>
                                {alert.comments == null ? "" : alert.comments}
                            </div>
                            {alert.startDate !== null && (
                                <div className={classes.alertBoldText}>
                                    {'Since' + ': ' + moment.utc(alert.startDate).format(config.defaultDateFormat)}
                                </div>
                            )}
                            <div className={classes.alertBoldText}>
                                {endDateStr}
                            </div>
                        </div>
                    </div>
                );
            }
        });

        return arr;

    }

    const handleClickAlert = (e) => {
        setAnchorEl(e.currentTarget);
        e.stopPropagation();
    };

    const handleClose = (e) => {
        setAnchorEl(null);
        e.stopPropagation();
    };


    return (
        <Box>
            <Popover
                classes={{
                    paper: "scroll-normal-grey headerPopover"
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {getPatientAlert()}
            </Popover>

            {props.patientObject?.alerts && <Tooltip title={t("Patient alerts")}>
                <IconButton
                    onClick={handleClickAlert}
                    size="large">
                    <StyledBadge
                        badgeContent={props.patientObject?.alerts?.length}
                        color={anchorEl ? "secondary" : "primary"}>
                        <AlertIcon/>
                    </StyledBadge>
                </IconButton>
            </Tooltip>
            }

        </Box>
    )
}
export default PatientAlertsComponent;